import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import useStore from './useStore';

const useDisableBodyScroll = () => {
  const { state } = useStore();
  const { isLoading } = state;

  const disableScroll = () => {
    const bodyEle = document.getElementsByTagName('body')?.[0];
    if (!isEmpty(bodyEle)) {
      bodyEle.style.overflowY = 'hidden';
      bodyEle.style.touchAction = 'none';
    }
  };

  const enableScroll = () => {
    const bodyEle = document.getElementsByTagName('body')?.[0];
    if (!isEmpty(bodyEle)) {
      bodyEle.style.overflowY = 'auto';
      bodyEle.style.touchAction = 'manipulation';
    }
  };

  const checkBackdropExisting = () => {
    const isBackdropGlobalExist =
      document.getElementsByClassName('backdrop-global')?.[0];
    const isBackdropCommonExist =
      document.getElementsByClassName('backdrop-common')?.[0];
    const isBackdropModalExist =
      document.getElementsByClassName('modal-backdrop')?.[0];
    if (isBackdropModalExist || isBackdropGlobalExist || isBackdropCommonExist)
      return true;
    return false;
  };

  useEffect(() => {
    if (isLoading || checkBackdropExisting()) {
      disableScroll();
    }
  }, [isLoading]);

  useEffect(() => {
    const listener = () => {
      if (checkBackdropExisting()) return;
      if (!isLoading) {
        enableScroll();
      }
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('wheel', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('wheel', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [isLoading]);
};

export default useDisableBodyScroll;
